import React, {useState, useEffect} from 'react';
import { Formik, Field, Form } from 'formik';
import { BsTicketPerforated } from "react-icons/bs";
import { CiCalendarDate } from "react-icons/ci";
import { TbExchange } from "react-icons/tb";
import {MdComputer} from 'react-icons/md';
import {AiOutlineHome} from 'react-icons/ai';
import {HiOutlineUser} from 'react-icons/hi';
import {BsPersonVcard} from 'react-icons/bs';
import {AiOutlineMessage} from 'react-icons/ai';
import {TbUrgent} from 'react-icons/tb';
import {MdOutlineManageAccounts} from 'react-icons/md';
import {TiMessages} from 'react-icons/ti';
import {ImAttachment} from 'react-icons/im';
import {MdNotificationsActive} from  'react-icons/md';
import {MdNotificationsOff} from  'react-icons/md';
import 'bootstrap/dist/css/bootstrap.min.css';

import './Ticket.css'
import appSettings from "../../appSettings.json";
import useFetch from '../../shared/hooks/useFetch';
import isFilled from '../../shared/utilities/isFilled';
import formatDateTime from '../../shared/utilities/formatDateTime';

const Ticket = (props) => {
    const { user, usersSAT, ticket, setTicket, setBodyUptTicket } = props

    const[notificar, setNotificar] = useState(ticket.notificar);

    const getTypes = `${appSettings.BASE_URL.default}/ticket/get-types`;
    const[dataTypes, setDataTypes] = useState("");
    const {serviceResponse: serviceResponseTypes, error: errorTypes, loading: loadingTypes} = useFetch(getTypes, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.token}, 'GET')

    useEffect(() => {
        if(!loadingTypes){
            setDataTypes(serviceResponseTypes.data)
        }
    }, [loadingTypes, serviceResponseTypes, errorTypes])
    
    const actTicketNotificar = () => {
        setNotificar(!notificar)
        setTicket({...ticket, notificar: !notificar})
    }

    return(
        <div className='container-fluid' style={{paddingTop: "15px"}}>
            <div className='row' style={{backgroundColor: "#ffffe1", borderRadius: "5px", paddingTop: "5px", marginBottom: "5px"}}>
                <div className='divIcon' style={{backgroundColor: "#ffff98"}}>
                    <BsTicketPerforated style={{color: "#afaf07"}} />
                </div>
                <div className='col'>
                    <span style={{fontSize: "16px", fontWeight: "350"}}><b>{ticket.caso}</b></span>
                    <br></br>
                    <span style={{color: "black", fontSize: "14px"}}><b>Ticket</b></span>
                </div>
            </div>
            <div className='row'>
                <div className='divIcon' style={{backgroundColor: "#bffdfa"}}>
                    <CiCalendarDate style={{color: "#00c8c8"}} />
                </div>
                <div className='col'>
                    <span style={{fontSize: "16px", fontWeight: "350"}}>{formatDateTime(ticket.creacion)}</span>
                    <br></br>
                    <span style={{color: "gray", fontSize: "14px"}}>Fecha de alta</span>
                </div>
            </div>
            <div className='row'>
                <div className='divIcon' style={{backgroundColor: "#ffcdf8"}}>
                    <TbExchange style={{color: "#a700c8"}} />
                </div>
                <div className='col'>
                    <span style={{fontSize: "16px", fontWeight: "350"}}>{ticket.estado}</span>
                    <br></br>
                    <span style={{color: "gray", fontSize: "14px"}}>Estado</span>
                </div>
            </div>
            <hr size = "4px"/>
            <div className='row'>
                <div className='divIcon' style={{backgroundColor: "#CDFFCD"}}>
                    <MdComputer style={{color: "#00C851"}} />
                </div>
                <div className='col'>
                    <span style={{fontSize: "16px", fontWeight: "350"}}>{ticket.erp}</span>
                    <br></br>
                    <span style={{color: "gray", fontSize: "14px"}}>ERP</span>
                </div>
            </div>
            <div className='row'>
                <div className='divIcon' style={{backgroundColor: "#FFE6CD"}}>
                    <AiOutlineHome style={{color: "#FF9C36"}}/>
                </div>
                <div className='col'>
                    <span style={{fontSize: "16px", fontWeight: "350"}}>{`${ticket.usuario.instalacion} - ${ticket.usuario.instalacionNombre}`}</span>
                    <br></br>
                    <span style={{color: "gray", fontSize: "14px"}}>Instalación</span>
                </div>
            </div>
            <div className='row'>
                <div className='divIcon' style={{backgroundColor: "#CDE6FF"}}>
                    <HiOutlineUser style={{color: "#3699FF"}}/>
                </div>
                <div className='col'>
                    <span style={{fontSize: "16px", fontWeight: "350"}}>{ticket.usuario.nombre}</span>
                    <br></br>
                    <span style={{color: "gray", fontSize: "14px"}}>Creador</span>
                </div>
            </div>
            <div className='row'>
                <div className='divIcon' style={{backgroundColor: "#E8DBEA"}}>
                    <BsPersonVcard style={{color: "#A471AA"}}/>
                </div>
                <div className='col'>
                    <span style={{fontSize: "16px", fontWeight: "350"}}>{`${ticket.usuario.usuarioId} - ${ticket.usuario.email}`}</span>
                    <br></br>
                    <span style={{color: "gray", fontSize: "14px"}}>Login</span>
                </div>
            </div>
            <Formik
                initialValues = {{
                    responsable: ticket.responsableNavigation.usuarioId,
                    tipo: ticket.tipo ? ticket.tipo.tipoId : "",
                    urgencia: ticket.urgencia,
                    asunto: ticket.asunto
                }}

                onSubmit = { (values) => {
                    const selectedType = isFilled(dataTypes) ? dataTypes.find(type => String(type.tipoId) === String(values.tipo)) : null
                    const updatedTipo = selectedType
                        ? {...ticket.tipo, tipoId: selectedType.tipoId, nombre: selectedType.nombre}
                        : ticket.tipo

                    setBodyUptTicket(JSON.stringify({
                        Ticket: {
                            ...ticket,
                            responsable: values.responsable,
                            urgencia: Number(values.urgencia),
                            asunto: values.asunto,
                            tipoId: values.tipo,
                            tipo: updatedTipo
                        }
                    }))
                }}
            >
                {({ isSubmitting }) => (
                <Form>
                    <div className='row'>
                        <div className='divIcon' style={{backgroundColor: "#FFF3E6"}}>
                            <AiOutlineMessage style={{color: "#FFCE9B"}}/>
                        </div>
                        <div className='col'>
                            {user.role == "7"
                            ?
                                <Field name="tipo" as="select" style={{border: "none", backgroundColor: "transparent"}} disabled = {!(ticket.estado == 'PENDIENTE' || ticket.estado == 'PROCESO')}>
                                    {isFilled(dataTypes) ? dataTypes.map((type, i) => (
                                        <option key={type.tipoId} value={type.tipoId}>{type.nombre}</option>
                                    )) : <option value={ticket.tipo.tipoId}>{ticket.tipo.nombre}</option>}
                                </Field>
                            :
                                <span style={{fontSize: "16px", fontWeight: "350"}}>{ticket.tipo.nombre}</span>
                            }
                            <br></br>
                            <span style={{color: "gray", fontSize: "14px"}}>Tipo</span>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='divIcon' style={{backgroundColor: "#E6F7FF"}}>
                            <AiOutlineMessage style={{color: "#1890FF"}}/>
                        </div>
                        <div className='col'>
                            {(user.role == "7" || user.idLogin == ticket.usuarioId)
                            ?
                                <Field name="asunto" type="text" style={{border: "none", backgroundColor: "transparent", width: "100%"}} disabled = {!(ticket.estado == 'PENDIENTE' || ticket.estado == 'PROCESO')} />
                            :
                                <span style={{fontSize: "16px", fontWeight: "350"}}>{ticket.asunto}</span>
                            }
                            <br></br>
                            <span style={{color: "gray", fontSize: "14px"}}>Asunto</span>
                        </div>
                    </div>
                    <div className='row' style={{display: (user.role == "7" || user.idLogin == ticket.usuarioId) ? '' : 'none'}}>
                        <div className='divIcon' style={{backgroundColor: "#E6CDFF"}}>
                            <TbUrgent style={{color: "#9C36FF"}}/>
                        </div>
                        <div className='col'>
                            <Field name="urgencia" as="select" style={{border: "none", backgroundColor: "transparent"}} disabled = {!(ticket.estado == 'PENDIENTE' || ticket.estado == 'PROCESO')}>
                                <option value="0">No urgente</option>
                                <option value="1">Urgente</option>
                            </Field>
                            <br></br>
                            <span style={{color: "gray", fontSize: "14px"}}>Urgencia</span>
                        </div>
                    </div>
                    <div className='row' style={{display: user.role == "7" ? '' : 'none'}}>
                        <div className='divIcon' style={{backgroundColor: "#FFCDCD"}}>
                            <MdOutlineManageAccounts style={{color: "#FF3836"}}/>
                        </div>
                        <div className='col'>
                            <Field name="responsable" as="select" style={{border: "none", backgroundColor: "transparent"}} disabled = {!(ticket.estado == 'PENDIENTE' || ticket.estado == 'PROCESO')}>
                                {isFilled(usersSAT) ? usersSAT.map((responsable, i) => (
                                    <option key={responsable.usuarioId} value={responsable.usuarioId}>{responsable.nombre}</option>
                                )) : <option value={ticket.responsableNavigation.usuarioId}>{ticket.responsableNavigation.nombre}</option>}
                            </Field>
                            <br></br>
                            <span style={{color: "gray", fontSize: "14px"}}>Responsable</span>
                        </div>
                    </div>
                    <div className='row' style={{marginBottom: "15px"}}>
                        <div className='divIcon' style={{backgroundColor: "#8692B9"}}>
                            {notificar == false 
                                ? <MdNotificationsOff onClick={() => actTicketNotificar()}/>
                                : <MdNotificationsActive onClick={() => actTicketNotificar()}/>
                            }
                        </div>
                        <div className='col'>
                            <span style={{fontSize: "16px", fontWeight: "350"}}>{notificar == true ? "Si" : "No"}</span>
                            <br></br>
                            <span style={{color: "gray", fontSize: "14px"}}>Notificar</span>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='divIcon' style={{backgroundColor: "#FAFBDB"}}>
                            <TiMessages style={{color: "D3DC00"}}/>
                        </div>
                        <div className='col'>
                            <span style={{fontSize: "16px", fontWeight: "350"}}>{ticket.mensaje.length}</span>
                            <br></br>
                            <span style={{color: "gray", fontSize: "14px"}}>Núm Mensajes</span>
                        </div>
                    </div>
                    <div className='row' style={{marginBottom: "15px"}}>
                        <div className='divIcon' style={{backgroundColor: "#B99F86"}}>
                            <ImAttachment style={{color: "#804000"}}/>
                        </div>
                        <div className='col'>
                            <span style={{fontSize: "16px", fontWeight: "350"}}>{ticket.adjunto.length}</span>
                            <br></br>
                            <span style={{color: "gray", fontSize: "14px"}}>Núm Adjuntos</span>
                        </div>
                    </div>
                    <div className='row' style={{marginBottom: "10px", display: (user.role == "7" || user.idLogin == ticket.usuarioId) && (ticket.estado == 'PENDIENTE' || ticket.estado == 'PROCESO') ? '' : 'none'}}>
                        <div className='col d-inline-flex '>
                            <button type="submit" className='btn btn-outline-success' data-bs-toggle="tooltip" data-bs-placement="top" title="Confirmar los cambios realizados">Confirmar cambios</button>
                        </div>
                    </div>
                </Form>
                )}
            </Formik>
            
        </div>
    )
}

export default Ticket;
